module.exports = __webpack_public_path__ + "static/media/customer-perdue.f5da8150.png";